module.exports = __webpack_public_path__ + "img/Notes.6158e14e.svg";